// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_8m0","cls2":"ReferenceEvaluationPage-cls2_Ahk ReferenceEvaluationPage-cls1_8m0"};